import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { AgentProfileDto, AgentVisibilitySettingsDto, AgentVisibilityUpdateDto } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '@workspace/ng-aura';
import { AgentVisibilityDisplayComponent } from '../display/agent-visibility-display.component';
import { AgentVisibilityFormComponent } from '../form/agent-visibility-form.component';

@Component({
  selector: 'etxe-agent-visibility-edit',
  imports: [AuraEditWrapperComponent, AgentVisibilityFormComponent, AgentVisibilityDisplayComponent],
  templateUrl: './agent-visibility-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentVisibilityEditComponent {
  readonly initialProfile = input<AgentProfileDto | null>(null);
  readonly initialSettings = input<AgentVisibilitySettingsDto | undefined>(undefined);
  readonly isEditing = model<boolean>(false);
  readonly isAllowedToEdit = input<boolean>(true);

  readonly saved = output<AgentVisibilityUpdateDto>();
  readonly profileSaved = output<AgentProfileDto>();

  readonly currentSettings = computed<AgentVisibilitySettingsDto | undefined>(() => {
    return this.initialSettings() ?? this.initialProfile()?.settings?.visibility;
  });

  onSave(dto: AgentVisibilityUpdateDto | null): void {
    if (!dto) return;
    this.saved.emit(dto);
    const profile = this.initialProfile();
    if (profile) {
      this.profileSaved.emit({
        ...profile,
        settings: {
          ...profile.settings,
          visibility: dto.visibility,
        },
      });
    }
  }
}
